import * as css from 'css/exports.module.scss';

import './AppHeader.scss';

import { BreadcrumbHeader } from './BreadcrumbHeader';
import classNames from 'classnames';
import { ImpersonatorNotice } from '@ui/ImpersonatorNotice';
import { NotificationsMenu } from './NotificationsMenu';
import React from 'react';
import { UserMenu } from './UserMenu';

import { Col, Row, Space } from 'antd';

export interface AppHeaderProps {
	hasDropShadow?: boolean;
}

export const AppHeader: React.FC<AppHeaderProps> = ({ hasDropShadow }) =>
	<div className={ classNames('app-header', { 'drop-shadow': hasDropShadow }) }>
		<Row
			align='middle'
			justify='space-between'>
			<Col>
				<BreadcrumbHeader />
			</Col>
			<Col>
				<Space
					align='center'
					size={ Number(css.size16) }>
					<ImpersonatorNotice />
					<NotificationsMenu />
					<UserMenu />
				</Space>
			</Col>
		</Row>
	</div>;

